import { render, staticRenderFns } from "./departmentStatistic.vue?vue&type=template&id=3ad486b3&scoped=true&"
import script from "./departmentStatistic.vue?vue&type=script&lang=js&"
export * from "./departmentStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad486b3",
  null
  
)

export default component.exports